export class CargoTypeModel {
  constructor(public id?: string, public name?: string) {}

  public fromJSON(json: any): CargoTypeModel {
    if (json) {
      this.id = json.id;
      this.name = json.name;
    }
    return this;
  }

  public fromJSONList(json: any): CargoTypeModel[] {
    if (json) {
      return json.map((element: any) => new CargoTypeModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      name: this.name,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.name ?? '';
  }
}
